import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getUserRoleByID, updateUserRole } from '../../../../controllers/UserRoleController';
import ButtonPrimary from '../../../../components/button/ButtonPrimary';
import ButtonSecondary from '../../../../components/button/ButtonSecondary';
import { toast } from 'react-hot-toast';
import Skeleton from '../../../../components/Skeleton';
import { useTranslation } from 'react-i18next';

const EditModal = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true)
    const [name, setName] = useState('');
    const isDisabled = useMemo(() => !name.trim(), [name]);
    
    useEffect(() => {
        const fetchRole = async () => {
            try {
                const result = await getUserRoleByID(id);
                const formattedRoleName = result.name.toLowerCase().replace(/\s(.)/g, (match) => match.toUpperCase()).replace(/\s/g, '');
                const translatedRoleName = t(`common.role.${formattedRoleName}`, { defaultValue: result.name });
                
                setName(translatedRoleName);
            } catch (error) {
                toast.error(error.message);
            } finally {
                setLoading(false);
            };
        };
        
        fetchRole();
    }, [id, t]);
    
    if (loading) {
        return (
            <Skeleton className='flex h-36 w-full rounded-lg' />
        ); 
    };
    
    const handleUpdate = async () => {
        try {
            await updateUserRole(id, { name });
            toast.success(t('userRole.add.message'));
            navigate('/user-role');
        } catch (error) {
            toast.error(error.message);
        };
    };
    
    const handleBack = () => {
        navigate('/user-role');
    };
    
    return (
        <div className='flex flex-col p-5 rounded-lg bg-white space-y-5'>
            <div className='flex flex-grow items-center'>
                <span className='w-36 text-xs md:text-sm'>{t('common.role.title')}:</span>
                <input
                    className={`
                        w-full px-3 py-2 rounded border border-platinum
                        hover:outline-none hover:border-grayX11
                        focus:outline-none focus:border-blackOlive text-xs md:text-sm
                    `}
                    type='text'
                    placeholder={t('common.role.placeholderText')}
                    value={name}
                    onChange={(e) => setName(e.target.value)} 
                />
            </div>
            <div className='flex justify-end space-x-5'>
                <ButtonSecondary className='h-full w-24 md:w-32 md:text-sm' onClick={handleBack}>{t('common.action.back')}</ButtonSecondary>
                <ButtonPrimary className='h-full w-24 md:w-32 md:text-sm' isDisabled={isDisabled} onClick={handleUpdate}>{t('common.action.edit')}</ButtonPrimary>
            </div>
        </div>
    );
};

export default EditModal;
